// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { SET_PRODUCT_DATA } from './types'

export const setProductData = (productUId, data) => ({
  type: SET_PRODUCT_DATA,
  productUId,
  data,
})
